import {combineReducers} from 'redux';

//import user from './user';
import user from './pages/user/user';
import login from './pages/user/login';
import verification from './pages/user/verification';
import referal from './pages/user/referal';
import edit_profile from './pages/user/edit_profile';
import allLoaders from './loaders';
import barcode_generate from './pages/buy/barcode_generate';
import installmentsBarcode from './pages/installments/barcode_generate';
import installmentsUpload from './pages/installments/upload_factor';
import main from './pages/main';
import shop from './pages/shop';
import shops from './pages/shops';
import transfer from './pages/transfer';
import custom_snackbar from './snackbar';
import wallet from './pages/wallet';
import charge_wallet from './pages/wallet/charge_wallet';
import withdraw from './pages/wallet/withdraw';
import bottom_sheet from './partials/footer/bottom_sheet';
import card_shop from './pages/main/card_shop';
import search from './pages/main/search';
import searchBranch from './partials/search/searchBranch';
import support from './pages/support';
import selectBranch from './pages/shop/selectBranch';

export default combineReducers({
    user, 
    login,
    verification,
    referal,
    allLoaders,
    barcode_generate,
    installmentsBarcode,
    installmentsUpload, 
    custom_snackbar,
    edit_profile,
    main,
    shop,
    shops,
    transfer,
    wallet, 
    bottom_sheet,
    card_shop,
    search,
    searchBranch,
    charge_wallet,
    withdraw,
    support,
    selectBranch
});
